import CustomDataGrid from 'utils/Datagrid/CustomCultureDataGrid';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CoProductEditCell,
  CoProductYieldEditCell,
  CustomCultureColorCell,
  CustomCultureInputCostCell,
  CustomCulturePriceCell,
  CustomEditCulturePriceCell,
  CustomHeaderWithoutSort,
  customCoProductsCell,
  copyCurrentValueToFuture,
  EditInputCell,
  handleRowUpdateValidation,
  EditNameCell,
  CustomNameCell,
  CustomCultureIFTCell,
  CustomGrossMarginCell,
  CustomMetaCultureCell,
  renderResetDialog,
  EditSelectCell,
} from 'utils/Datagrid/CustomCultureDataGridUtils';
import { toast } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import './cultures.styles.scss';
import useCustomEditColorCell from 'utils/Datagrid/useCustomEditColorCell';
import { getCultures, getMetacultureList, updateCulture } from 'services/API/Cooperative';
import {
  resetSectorCultures,
  updateCulture as updateSectorCulture,
} from '../../../services/API/Secteur';
import {
  resetCultures,
  updateCulture as updateExploitationCulture,
} from '../../../services/API/Exploitation';
import {
  checkDecimalNegativeDatagrid,
  checkDecimalRegexTwoDigitsDatagridValue,
  checkEmptyFieldAndDecimalRegexDatagridValue,
  checkEmptyFieldAndNoDecimalDatagridInteger,
  checkNoDecimalRegexTwoDigitsDatagridValue,
  checkTypeStringRegexDatagrid,
  displayErrorMessage,
  getOnlyAttributeUpdated,
  getStringInsideParentheses,
} from 'utils/tools_functions';
import Button from '@mui/material/Button';
import {
  inputAbsolutePositiveFloatValidator,
  inputDurationValidator,
  inputExtraCostValidator,
  inputIFTValidator,
  inputIntegerValidator,
  inputNitrogenValidator,
  inputNumberRequired,
  inputPositiveFloatValidator,
  inputPositiveNotNullFloatValidator,
  inputRequired,
  inputUnique,
  inputVerifyCultureAndPresenceDuration,
  inputVerifyName,
  inputVerifySeason,
  inputYieldValidator,
} from 'components/generics/Validators/validator';
import { validateDatagridData } from '../../generics/Validators/datagrid.validate';
import InputCostModalNitrogen from './form/InputCostModalNitrogen';
import {
  CustomSortableHeader,
  processColumns,
  resetErrorsForm,
} from 'utils/Datagrid/CustomGenericDataGridUtils';
import { customButtonTheme } from 'assets/styles/themes/generic_button_mui';
import useDataGridCulturesActions from 'utils/Datagrid/useDataGridCulturesActions';
import useDataGridCultureVisibility from 'utils/Datagrid/useDataGridCultureVisibility';
import AddCultureModalNitrogen from './form/AddCultureModalNitrogen';
import IFTModal from './form/IFTModal';
import { Box } from '@mui/material';
import InputCostModal from './form/InputCostModal';
import AddCultureModal from './form/AddCultureModal';
import OffCropSettingsModal from './form/OffCropSettingsModal';
import MetaCultureModal from './form/MetaCultureModal';
import useToggleSwitch from 'utils/hooks/useToggleSwitch';
import { getCultureSeasonLabels } from 'components/generics/Interface/ICulture';
import { getCultureTypeLabels } from 'utils/GlobalVariables';

const DataGridCulture = ({
  columnsDefinition,
  from,
  cultures,
  refreshData,
  user,
  sector,
  exploitation,
  coProductsList,
  economicAttribute,
  cooperativeId,
  cooperativeName,
  nitrogenCover,
  nitrogenSupplyByCoverOrganic,
  getOffCropSettings,
  biomassSupplyByCover,
}) => {
  const [rows, setRows] = useState([]);
  const [dataGridLoading, setDataGridLoading] = useState(false);
  const [sortModel, setSortModel] = useState([
    {
      field: 'name',
      sort: 'asc',
    },
  ]);
  const [addCultureModal, setAddCultureModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const renderColorEditCell = useCustomEditColorCell(cultures);
  const { t } = useTranslation();
  const [openInputCostDialog, setOpenInputCostDialog] = useState(false);
  const [errorsFormDefault, setErrorsFormDefault] = useState({
    formError: false,
    name: {
      message: '',
      validator: [inputRequired, inputVerifyName, inputUnique],
    },
    inputCostWithoutNitrogen: {
      message: '',
      validator: [inputNumberRequired, inputPositiveFloatValidator],
    },
    inputCostWithoutNitrogenN5: {
      message: '',
      validator: [inputPositiveFloatValidator],
    },
    extraCost: {
      message: '',
      validator: [inputExtraCostValidator],
    },
    tfiHerbicide: {
      message: '',
      validator: [inputPositiveNotNullFloatValidator, inputIFTValidator],
    },
    tfiWithoutHerbicide: {
      message: '',
      validator: [inputPositiveNotNullFloatValidator, inputIFTValidator],
    },
    presenceDuration: {
      message: '',
      params: ['cultureType', 'cultureSeason'],
      validator: [
        inputNumberRequired,
        inputIntegerValidator,
        inputDurationValidator,
        inputVerifyCultureAndPresenceDuration,
      ],
    },
    prohibitionDuration: {
      message: '',
      validator: [inputNumberRequired, inputIntegerValidator, inputDurationValidator],
    },
    yield: {
      message: '',
      validator: [inputNumberRequired, inputPositiveFloatValidator, inputYieldValidator],
    },
    irrigationYieldGain: {
      message: '',
      validator: [inputNumberRequired, inputPositiveFloatValidator],
    },
    irrigationWaterNeeded: {
      message: '',
      validator: [inputNumberRequired, inputPositiveFloatValidator],
      // reset key needed to reset validator to their initial value after a third validator has been added py preProcessEditCellProps
      resetValidator: [inputNumberRequired, inputPositiveFloatValidator],
    },
    nitrogenBonus: {
      message: '',
      validator: [inputIntegerValidator],
    },
    nitrogenLimit: {
      message: '',
      validator: [inputIntegerValidator],
    },
    necessaryNitrogenQuantity: {
      message: '',
      validator: [inputIntegerValidator, inputNitrogenValidator],
    },
    cultureSeason: {
      message: '',
      params: 'cultureType',
      validator: [inputVerifySeason],
    },
  });
  const [errorsFormCoProduct, setErrorsFormCoProduct] = useState({
    formError: false,
    yield: {
      message: '',
      validator: [inputNumberRequired, inputAbsolutePositiveFloatValidator],
    },
  });
  const [errorCoProductsMessages, setErrorCoProductsMessages] = useState([]);
  const [errorsFormEconomicValue, setErrorsFormEconomicValue] = useState({
    formError: false,
    price: {
      message: '',
      validator: [inputNumberRequired, inputPositiveFloatValidator],
    },
    priceN5: {
      message: '',
      validator: [inputPositiveFloatValidator],
    },
  });
  const [errorsFormOffCropSettings, setErrorsFormOffCropSettings] = useState({
    formError: false,
    nitrogenPrice: {
      message: '',
      validator: [inputPositiveFloatValidator],
    },
    nitrogenPriceN5: {
      message: '',
      validator: [inputPositiveFloatValidator],
    },
    nitrogenSupplyByCover: {
      message: '',
      validator: [inputIntegerValidator],
    },
    biomassSupplyByCover: {
      message: '',
      validator: [inputPositiveFloatValidator],
    },
  });
  const [errorsFormMetaculture, setErrorsFormMetaculture] = useState({
    formError: false,
    metaCode: {
      message: '',
      validator: [],
    },
  });
  const [metacultureValue, setMetacultureValue] = useState({
    metaCultureName: '',
    metaCode: '',
    rootBiomass: 0,
    aerialBiomass: 0,
    isArable: false,
    capCategory: '',
    cultureId: 0,
  });
  const [openMetacultureDialog, setOpenMetacultureDialog] = useState(false);
  const [isEditMetaculture, setIsEditMetaculture] = useState(false);
  const [metaculture, setMetaculture] = useState(null);
  const priceTabsValuesRef = useRef([]);
  const grossMarginTabsValuesRef = useRef([]);
  const inputCostTabsValuesRef = useRef([]);
  const [inputCostValue, setInputCostValue] = useState({
    inputCost: 0,
    inputCostN5: 0,
    inputCostWithoutNitrogen: 0,
    inputCostWithoutNitrogenN5: 0,
    necessaryNitrogenQuantity: 0,
    cultureId: 0,
  });
  const [paramsInputCost, setParamsInputCost] = useState({
    inputCost: false,
    inputCostN5: false,
  });
  const [isEditCoProduct, setIsEditCoProduct] = useState(false);
  const [isEditInputCost, setIsEditInputCost] = useState(false);
  const [isEditableIFT, setIsEditableIFT] = useState(false);
  const [openIFTDialog, setOpenIFTDialog] = useState(false);
  const [IFTValue, setIFTtValue] = useState({
    tfiHerbicide: 0,
    tfiWithoutHerbicide: 0,
    cultureId: 0,
  });
  const [nitrogenPriceValue, setNitrogenPriceValue] = useState(economicAttribute);
  const [coProductYieldFocus, setCoProductYieldFocus] = useState({});
  const [openOffCropSettingsDialog, setOpenOffCropSettingsDialog] = useState(false);
  const [openResetDialog, setOpenResetDialog] = useState(false);
  const [invertedCultures, setInvertedCultures] = useState([]);
  const [toggleAction, setToggleAction] = useState(false);
  const [hasCustomizedCulture, setHasCustomizedCulture] = useState(false);
  const [hasErrorOnOrganicState, setHasErrorOnOrganicState] = useState(false);
  const stackedRequestsRef = useRef([]);

  const errorsFormDefaultArray = [
    { ...errorsFormDefault },
    { ...errorsFormCoProduct },
    { ...errorsFormEconomicValue },
    { ...errorsFormOffCropSettings },
    { ...errorsFormMetaculture },
  ];

  const hasFormErrors = (errors) => {
    if (Array.isArray(errors)) {
      return errors.some((error) => error.formError);
    }
    return Object.values(errors).some((error) => error.formError);
  };

  useEffect(() => {
    if (errorsFormDefaultArray) {
      const hasError = hasFormErrors(errorsFormDefaultArray);
      setHasErrorOnOrganicState(hasError);
    }
  }, [errorsFormDefaultArray]);

  const { renderToggleSwitch, isOrganic } = useToggleSwitch(
    from === 'fromCooperative'
      ? 'cooperatives'
      : from === 'fromSector'
        ? 'sectors'
        : from === 'fromExploitation'
          ? 'exploitations'
          : false,
    'cultures',
    refreshData,
    from === 'fromCooperative' ? cooperativeId : sector ? sector?.id : exploitation?.id,
    stackedRequestsRef,
    hasErrorOnOrganicState,
  );

  const organicState = isOrganic ? 'organic' : 'conventional';

  useEffect(() => {
    if (toggleAction) {
      loadInvertedCultureBySwitch();
    }
  }, [toggleAction, isOrganic]);

  const loadInvertedCultureBySwitch = async () => {
    try {
      const result = await getCultures(cooperativeId, !isOrganic);
      setInvertedCultures(result.data?.data);
    } catch (error) {
      setAddCultureModal(false);
      toast.error(displayErrorMessage('ERR_GET_CULTURE'));
    }
  };

  const checkCustomizedCulture = async (id) => {
    if (cultures.length && invertedCultures.length) {
      const culture = cultures.find((culture) => culture.id === id);
      const invertedCulture = invertedCultures.find((culture) => culture.id === id);
      const isCustomized = culture?.isCustomized && invertedCulture?.isCustomized;

      setHasCustomizedCulture(isCustomized || false);
    }
  };

  const {
    rowModesModel,
    setRowModesModel,
    getActions,
    renderDeleteDialog,
    renderDuplicateDialog,
    renderDeleteEffectsDialog,
  } = useDataGridCulturesActions(
    user,
    rows,
    refreshData,
    isOrganic,
    cultures,
    errorsFormDefault,
    errorsFormCoProduct,
    errorsFormEconomicValue,
    from === 'fromCooperative' ? true : false,
    from === 'fromExploitation' ? true : false,
    exploitation,
    cooperativeId,
    invertedCultures,
    checkCustomizedCulture,
    hasCustomizedCulture,
    setToggleAction,
    stackedRequestsRef,
  );

  useEffect(() => {
    if (rows.length) {
      priceTabsValuesRef.current = rows.map((row) => ({ id: row.id, value: 0 }));
      inputCostTabsValuesRef.current = rows.map((row) => ({ id: row.id, value: 0 }));
      grossMarginTabsValuesRef.current = rows.map((row) => ({ id: row.id, value: 0 }));
    }
  }, [rows.length]);

  useEffect(() => {
    setDataGridLoading(true);
    if (lastSelectedRows?.[organicState]?.ids?.size && toggleVisibilityFilter?.[organicState]) {
      processedRows &&
        setRows(
          processedRows?.filter(
            (culture) => !lastSelectedRows?.[organicState]?.ids?.has(culture.id),
          ),
        );
    } else {
      processedRows && setRows(processedRows);
    }
    setDataGridLoading(false);
  }, [cultures]);

  const processedRows = cultures
    ?.filter((culture) => culture.isCustomized === true)
    .map((culture) => {
      const grossMargin =
        culture.economicAttributeCollection?.price?.currentEconomicValue * culture.yield -
        culture.economicAttributeCollection?.inputCost?.currentEconomicValue -
        culture?.extraCost;

      const grossMarginN5 =
        (culture.economicAttributeCollection?.price?.futureEconomicValue ??
          culture.economicAttributeCollection?.price?.currentEconomicValue) *
          culture.yield -
        (culture.economicAttributeCollection?.inputCost?.futureEconomicValue ??
          culture.economicAttributeCollection?.inputCost?.currentEconomicValue) -
        culture?.extraCost;
      return {
        id: culture.id,
        name: culture.name,
        ...(culture.parentCultureName && { parentName: culture.parentCultureName }),
        color: culture.color,
        price: culture.economicAttributeCollection?.price?.currentEconomicValue ?? null,
        priceN5:
          culture.economicAttributeCollection?.price?.futureEconomicValue ??
          culture.economicAttributeCollection?.price?.currentEconomicValue ??
          null,
        inputCost: culture.economicAttributeCollection?.inputCost?.currentEconomicValue ?? null,
        inputCostN5:
          culture.economicAttributeCollection?.inputCost?.futureEconomicValue ??
          culture.economicAttributeCollection?.inputCost?.currentEconomicValue ??
          null,
        inputCostWithoutNitrogen:
          culture.economicAttributeCollection?.inputCostWithoutNitrogen?.currentEconomicValue ??
          null,
        inputCostWithoutNitrogenN5:
          culture.economicAttributeCollection?.inputCostWithoutNitrogen?.futureEconomicValue ??
          culture.economicAttributeCollection?.inputCostWithoutNitrogen?.currentEconomicValue ??
          null,
        yield: culture.yield,
        nitrogenBonus: culture.nitrogenBonus ?? 0,
        nitrogenLimit: culture.nitrogenLimit ?? 0,
        necessaryNitrogenQuantity: culture.necessaryNitrogenQuantity ?? 0,
        tfi: culture.tfi,
        tfiHerbicide: culture.tfiHerbicide,
        tfiWithoutHerbicide: culture.tfiWithoutHerbicide,
        presenceDuration: culture.presenceDuration,
        prohibitionDuration: culture.prohibitionDuration,
        coProducts: culture.coProducts,
        coProduct: culture.coProducts?.map((coProduct) => coProduct.displayName),
        yieldProduct: culture.coProducts?.map((coProduct) => coProduct.yield),
        irrigationYieldGain: culture.irrigationYieldGain,
        irrigationWaterNeeded: culture.irrigationWaterNeeded,
        capCategory: culture.capCategory ?? t('common.noneFeminine'),
        cultureSeason: culture.cultureSeason ?? '',
        cultureType: culture.cultureType,
        isStrawProducer: culture.isStrawProducer,
        extraCost: culture.extraCost,
        isIrrigableOnly: culture.isIrrigableOnly,
        isArable: culture.isArable,
        grossMargin: grossMargin,
        grossMarginN5: grossMarginN5,
        extraBiomass: culture.extraBiomass ?? '0',
        aerialBiomass: culture.aerialBiomass ?? 0,
        rootBiomass: culture.rootBiomass ?? 0,
        metaCode:
          culture.metaCultureName && culture.metaCode
            ? culture.metaCode + '-' + culture.metaCultureName
            : t('common.none'),
        metaCultureName: culture.metaCultureName,
        isOrganic: culture.isOrganic,
        firstSimulateEnabled: culture.firstSimulateEnabled,
      };
    });

  const isOpenYieldCoProduct = errorsFormCoProduct.formError;
  const isOpen = errorsFormDefault.formError;
  const isOpenPrice = errorsFormEconomicValue.formError;

  const renderPriceCell = (params) => {
    return (
      <CustomCulturePriceCell
        priceTabsValues={priceTabsValuesRef}
        id={params.id}
        value={params.value}
        row={params.row}
      />
    );
  };

  const renderGrossMarginCell = (params) => {
    return (
      <CustomGrossMarginCell {...params} grossMarginTabsValuesRef={grossMarginTabsValuesRef} />
    );
  };

  const renderCoProductYieldEditCell = (params) => {
    return (
      <CoProductYieldEditCell
        errorsFormCoProduct={errorsFormCoProduct}
        errorCoProductsMessages={errorCoProductsMessages}
        isOpen={isOpenYieldCoProduct}
        coProductYieldFocus={coProductYieldFocus}
        {...params}
      />
    );
  };

  const renderEditPriceCell = (params) => {
    return (
      <CustomEditCulturePriceCell
        {...params}
        params={params}
        errorsFormEconomicValue={errorsFormEconomicValue}
        isOpen={isOpenPrice}
        priceTabsValuesRef={priceTabsValuesRef}
      />
    );
  };

  const renderNameEditCell = (params) => {
    return <EditNameCell params={params} errorsFormDefault={errorsFormDefault} isOpen={isOpen} />;
  };

  const renderCoProductEditCell = (params) => {
    return (
      <CoProductEditCell
        coProductsList={coProductsList}
        setIsEditCoProduct={setIsEditCoProduct}
        {...params}
      />
    );
  };

  const {
    toggleVisibilityFilter,
    columnVisible,
    selectedRows,
    setSelectedRows,
    setColumnVisible,
    handleVisibility,
    handleCulturesHide,
    handleCulturesShow,
    badgeContent,
    isLargeGrid,
    lastSelectedRows,
  } = useDataGridCultureVisibility(rows, setRows, processedRows, from, user, organicState);

  const allColumns = [
    {
      field: 'name',
      headerName: t('common.name'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      cellClassName: 'culture-center-cell',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 180,
      sortable: false,
      editable: true,
      renderCell: (params) => CustomNameCell(params.row.name),
      valueParser: (value) => {
        return checkTypeStringRegexDatagrid(value);
      },
      renderEditCell: (params) =>
        params.row?.parentName
          ? renderNameEditCell(params)
          : EditInputCell(params, errorsFormDefault, isOpen),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'name'}
          name={t('common.name')}
        />
      ),
    },
    {
      field: 'color',
      headerName: t('column.color'),
      type: 'string',
      headerClassName: 'forecast-header',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 130,
      sortable: false,
      editable: true,
      renderCell: (params) => CustomCultureColorCell(params?.row?.color),
      renderEditCell: renderColorEditCell,
      renderHeader: () => <CustomHeaderWithoutSort name={t('column.color')} />,
    },
    {
      field: 'price',
      headerName: t('column.sellingPrice'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      valueParser: (value) => {
        return checkDecimalRegexTwoDigitsDatagridValue(value);
      },
      renderCell: renderPriceCell,
      renderEditCell: (props) => renderEditPriceCell(props),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'price'}
          name={t('column.sellingPrice')}
        />
      ),
    },
    {
      field: 'priceN5',
      headerName: t('column.priceN5'),
      type: 'number',
      sortable: false,
      editable: true,
    },
    {
      field: 'grossMargin',
      headerName: t('column.grossMargin'),
      headerClassName: isLargeGrid ? 'culture-header-full' : 'culture-header-light',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: false,
      renderCell: renderGrossMarginCell,
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'grossMargin'}
          optionnalName={t('column.grossMarginTooltip')}
          name={t('column.grossMargin')}
        />
      ),
    },
    {
      field: 'grossMarginN5',
      headerName: t('column.grossMarginN5'),
      type: 'number',
      sortable: false,
      editable: false,
    },
    {
      field: 'inputCost',
      headerName: t('column.inputCost'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      type: 'number',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: false,
      renderCell: (params) =>
        CustomCultureInputCostCell(
          params,
          openInputCostDialog,
          setOpenInputCostDialog,
          setInputCostValue,
          setParamsInputCost,
          isEditInputCost,
          inputCostTabsValuesRef,
        ),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'inputCost'}
          optionnalName={t('column.inputCostTooltip')}
          name={t('column.inputCost')}
        />
      ),
    },
    {
      field: 'inputCostN5',
      headerName: t('column.inputCostN5'),
      type: 'number',
      sortable: false,
      editable: false,
    },
    {
      field: 'inputCostWithoutNitrogen',
      headerName: t('column.inputCostWithoutNitrogen'),
      type: 'number',
      sortable: false,
      editable: false,
    },
    {
      field: 'inputCostWithoutNitrogenN5',
      headerName: t('column.inputCostWithoutNitrogenN5'),
      type: 'number',
      sortable: false,
      editable: false,
    },
    {
      field: 'yield',
      headerName: t('column.yield'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      valueParser: (value) => {
        return checkDecimalRegexTwoDigitsDatagridValue(value);
      },
      renderEditCell: (props) => EditInputCell(props, errorsFormDefault, isOpen),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'yield'}
          optionnalName={t('column.yieldTooltip')}
          name={t('column.yield')}
        />
      ),
    },
    {
      field: 'nitrogenBonus',
      headerName: t('column.nitrogenBonus'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      valueParser: (value) => {
        return checkEmptyFieldAndNoDecimalDatagridInteger(value);
      },
      renderEditCell: (props) => EditInputCell(props, errorsFormDefault, isOpen),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'nitrogenBonus'}
          optionnalName={t('column.nitrogenBonusTooltip')}
          name={t('column.nitrogenBonus')}
        />
      ),
    },
    {
      field: 'nitrogenLimit',
      headerName: t('column.nitrogenLimit'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      valueParser: (value) => {
        return checkEmptyFieldAndNoDecimalDatagridInteger(value);
      },
      renderEditCell: (props) => EditInputCell(props, errorsFormDefault, isOpen),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'nitrogenLimit'}
          optionnalName={t('column.nitrogenLimitTooltip')}
          name={t('column.nitrogenLimit')}
        />
      ),
    },
    {
      field: 'necessaryNitrogenQuantity',
      headerName: t('column.nitrogenNeed'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      valueParser: (value) => {
        return checkNoDecimalRegexTwoDigitsDatagridValue(value);
      },
      renderEditCell: (props) => EditInputCell(props, errorsFormDefault, isOpen),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'necessaryNitrogenQuantity'}
          optionnalName={t('column.nitrogenNeedTooltip')}
          name={t('column.nitrogenNeed')}
        />
      ),
    },
    {
      field: 'tfi',
      headerName: `IFT`,
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: false,
      renderCell: (params) =>
        CustomCultureIFTCell(params, isEditableIFT, openIFTDialog, setOpenIFTDialog, setIFTtValue),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'ift'}
          optionnalName={t('column.iftTooltip')}
          name={t('common.ift')}
        />
      ),
    },
    {
      field: 'tfiHerbicide',
      headerName: t('column.tfiHerbicide'),
      type: 'number',
      sortable: false,
      editable: false,
    },
    {
      field: 'tfiWithoutHerbicide',
      headerName: t('column.tfiWithoutHerbicide'),
      type: 'number',
      sortable: false,
      editable: false,
    },
    {
      field: 'presenceDuration',
      headerName: t('form.presenceDuration'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      valueParser: (value) => {
        return checkNoDecimalRegexTwoDigitsDatagridValue(value);
      },
      renderEditCell: (props) => EditInputCell(props, errorsFormDefault, isOpen),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'presenceDuration'}
          optionnalName={t('column.presenceDurationTooltip')}
          name={t('form.presenceDuration')}
        />
      ),
    },
    {
      field: 'prohibitionDuration',
      headerName: t('common.prohibitionDuration'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      valueParser: (value) => {
        return checkNoDecimalRegexTwoDigitsDatagridValue(value);
      },
      renderEditCell: (props) => EditInputCell(props, errorsFormDefault, isOpen),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'prohibitionDuration'}
          optionnalName={t('column.prohibitionDurationTooltip')}
          name={t('common.prohibitionDuration')}
        />
      ),
    },
    {
      field: 'coProduct',
      headerName: t('column.coProduct'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      renderEditCell: renderCoProductEditCell,
      renderCell: (params) => customCoProductsCell(params.value, setCoProductYieldFocus),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'coProduct'}
          optionnalName={t('column.coProductTooltip')}
          name={t('column.coProduct')}
        />
      ),
    },
    {
      field: 'yieldProduct',
      headerName: t('column.coProductYield'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      renderCell: (params) => customCoProductsCell(params.value, setCoProductYieldFocus),
      renderEditCell: renderCoProductYieldEditCell,
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'yieldProduct'}
          optionnalName={t('column.coProductYieldTooltip')}
          name={t('column.coProductYield')}
        />
      ),
    },
    {
      field: 'irrigationYieldGain',
      headerName: t('column.irrigationYieldGain'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      valueParser: (value) => {
        return checkDecimalRegexTwoDigitsDatagridValue(value);
      },
      renderEditCell: (props) => EditInputCell(props, errorsFormDefault, isOpen),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'irrigationYieldGain'}
          optionnalName={t('column.irrigationYieldGainTooltip')}
          name={t('column.irrigationYieldGain')}
        />
      ),
    },
    {
      field: 'irrigationWaterNeeded',
      headerName: t('column.irrigationWaterNeeded'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      valueParser: (value) => {
        return checkDecimalRegexTwoDigitsDatagridValue(value);
      },
      renderEditCell: (props) => EditInputCell(props, errorsFormDefault, isOpen),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'irrigationWaterNeeded'}
          optionnalName={t('column.irrigationWaterNeededTooltip')}
          name={t('column.irrigationWaterNeeded')}
        />
      ),
    },
    {
      field: 'capCategory',
      headerName: t('form.capCategoryLabel'),
      type: 'singleSelect',
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      cellClassName: 'culture-center-cell',
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: false,
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'capCategory'}
          name={t('form.capCategoryLabel')}
        />
      ),
    },
    {
      field: 'cultureSeason',
      headerName: t('column.season'),
      type: 'singleSelect',
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      editable: true,
      sortable: false,
      valueOptions: () =>
        Object.entries(getCultureSeasonLabels(t)).map(([value, label]) => ({ value, label })),
      renderEditCell: (props) => EditSelectCell(props, errorsFormDefault, isOpen),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'cultureSeason'}
          optionnalName={t('form.summerOrWinter')}
          name={t('column.season')}
        />
      ),
    },
    {
      field: 'cultureType',
      headerName: t('column.cultureType'),
      type: 'singleSelect',
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      editable: true,
      sortable: false,
      valueOptions: () =>
        Object.entries(getCultureTypeLabels(t)).map(([value, label]) => ({ value, label })),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'cultureType'}
          name={t('column.cultureType')}
        />
      ),
    },
    {
      field: 'isStrawProducer',
      headerName: t('column.strawCulture'),
      type: 'boolean',
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      type: 'boolean',
      editable: true,
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'isStrawProducer'}
          name={t('column.strawCulture')}
        />
      ),
    },
    {
      field: 'extraCost',
      headerName: t('column.extraCost'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      valueFormatter: (value) => (!value || value === 0 ? '-' : value),
      valueParser: (value) => {
        if (value.length === 0 || !value.length) {
          value = '0';
        }
        return checkDecimalNegativeDatagrid(value);
      },
      renderEditCell: (props) => EditInputCell(props, errorsFormDefault, isOpen),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'extraCost'}
          optionnalName={t('column.extraCostTooltip')}
          name={t('column.extraCost')}
        />
      ),
    },
    {
      field: 'isIrrigableOnly',
      headerName: t('column.mandatoryIrrigation'),
      type: 'boolean',
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      preProcessEditCellProps: (params) => {
        if (params.props.value) {
          setErrorsFormDefault({
            ...errorsFormDefault,
            irrigationWaterNeeded: {
              ...errorsFormDefault?.irrigationWaterNeeded,
              validator: [
                ...new Set([
                  ...errorsFormDefault?.irrigationWaterNeeded?.validator,
                  inputAbsolutePositiveFloatValidator,
                ]),
              ],
            },
          });

          return { ...params.props };
        }
        setErrorsFormDefault({
          ...errorsFormDefault,
          irrigationWaterNeeded: {
            ...errorsFormDefault?.irrigationWaterNeeded,
            validator: [inputNumberRequired, inputPositiveFloatValidator],
          },
        });

        return { ...params.props };
      },
      editable: true,
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'isIrrigableOnly'}
          name={t('column.mandatoryIrrigation')}
        />
      ),
    },
    {
      field: 'isArable',
      headerName: t('form.isArable'),
      type: 'boolean',
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: false,
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'isArable'}
          name={t('form.isArable')}
        />
      ),
    },
    {
      field: 'extraBiomass',
      headerName: t('column.extraDryMatter'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: true,
      valueParser: (value) => {
        return checkEmptyFieldAndDecimalRegexDatagridValue(value, 1);
      },
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'extraBiomass'}
          name={t('column.extraDryMatter')}
        />
      ),
    },
    {
      field: 'aerialBiomass',
      headerName: t('column.aerialBiomassCoefficient'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: false,
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'aerialBiomass'}
          name={t('column.aerialBiomassCoefficient')}
        />
      ),
    },
    {
      field: 'rootBiomass',
      headerName: t('column.rootBiomassCoefficient'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: false,
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'rootBiomass'}
          name={t('column.rootBiomassCoefficient')}
        />
      ),
    },
    {
      field: 'metaCode',
      headerName: t('common.cultureCode'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: false,
      cellClassName: 'meta-culture-name',
      renderCell: (params) =>
        CustomMetaCultureCell(
          params,
          isEditMetaculture,
          openMetacultureDialog,
          setOpenMetacultureDialog,
          setMetacultureValue,
        ),
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'metaCode'}
          name={t('common.cultureCode')}
        />
      ),
    },
    {
      field: 'metaCultureName',
      headerName: t('column.cultureName'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
      minWidth: 160,
      sortable: false,
      editable: false,
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'metaCultureName'}
          name={t('column.cultureName')}
        />
      ),
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t('common.actions'),
      flex: 1,
      minWidth: 160,
      headerAlign: 'center',
      align: 'center',
      cellClassName: 'actions',
      getActions: getActions,
      renderHeader: () => <CustomHeaderWithoutSort name={t('common.actions')} />,
    },
    {
      field: 'firstSimulateEnabled',
      headerName: t('column.activeByDefault'),
      headerClassName: `${isLargeGrid ? 'culture-header-full' : 'culture-header-light'}`,
      cellClassName: 'culture-center-cell',
      headerAlign: 'center',
      align: 'center',
      type: 'boolean',
      flex: 1,
      minWidth: 180,
      sortable: false,
      editable: true,
      renderHeader: () => (
        <CustomSortableHeader
          setSortModel={setSortModel}
          fieldName={'firstSimulateEnabled'}
          name={t('column.activeByDefault')}
        />
      ),
    },
  ];

  const hiddenN5Columns = () => {
    const priceN5Column = allColumns.find((column) => column.field === 'priceN5');
    const inputCostN5Column = allColumns.find((column) => column.field === 'inputCostN5');
    const tfiHerbicideColumn = allColumns.find((column) => column.field === 'tfiHerbicide');
    const tfiWithoutHerbicideColumn = allColumns.find(
      (column) => column.field === 'tfiWithoutHerbicide',
    );
    const inputCostWithoutNitrogenColumn = allColumns.find(
      (column) => column.field === 'inputCostWithoutNitrogen',
    );
    const inputCostWithoutNitrogenN5Column = allColumns.find(
      (column) => column.field === 'inputCostWithoutNitrogenN5',
    );
    const grossMarginN5Column = allColumns.find((column) => column.field === 'grossMarginN5');
    const metaCultureNameColumn = allColumns.find((column) => column.field === 'metaCultureName');

    return [
      priceN5Column,
      inputCostN5Column,
      tfiHerbicideColumn,
      tfiWithoutHerbicideColumn,
      inputCostWithoutNitrogenColumn,
      inputCostWithoutNitrogenN5Column,
      grossMarginN5Column,
      metaCultureNameColumn,
    ];
  };

  const handleExceptionsRights = (data) => {
    return data.map((processedColumn) => {
      if (processedColumn.field === 'capCategory' && from === 'fromExploitation') {
        return { ...processedColumn, editable: false };
      }
      if (processedColumn.field === 'tfi') {
        return { ...processedColumn, editable: true };
      }
      if (processedColumn.field === 'inputCost') {
        return { ...processedColumn, editable: true };
      }
      if (processedColumn.field === 'metaCode' && from === 'fromCooperative') {
        return { ...processedColumn, editable: true };
      }
      return processedColumn;
    });
  };

  const processedColumns = handleExceptionsRights([
    ...processColumns(allColumns, columnsDefinition),
    ...hiddenN5Columns(),
  ]);

  const isInputCostEditable = processedColumns.some(
    (processedColumn) => processedColumn.field === 'inputCost' && processedColumn.editable,
  );

  const isIFTEditable = processedColumns.some(
    (processedColumn) => processedColumn.field === 'tfi' && processedColumn.editable,
  );

  const isMetacultureEditable = processedColumns.some(
    (processedColumn) => processedColumn.field === 'metaCode' && processedColumn.editable,
  );

  useEffect(() => {
    if (isInputCostEditable) {
      setIsEditInputCost(true);
    }
    if (isIFTEditable) {
      setIsEditableIFT(true);
    }
    if (isMetacultureEditable) {
      setIsEditMetaculture(true);
    }
  }, [isInputCostEditable, isIFTEditable, isMetacultureEditable]);

  const formSuccess = () => {
    setAddCultureModal(false);
    setEditData(null);
    refreshData(
      isOrganic,
      from === 'fromCooperative' ? cooperativeId : sector ? sector?.id : exploitation?.id,
    );
  };

  const loadMetacultureData = async () => {
    try {
      const result = await getMetacultureList();
      setMetaculture(result.data?.data);
    } catch (error) {
      setOpenMetacultureDialog(false);
      toast.error(displayErrorMessage('ERR_GET_METACULTURE'));
    }
  };

  useEffect(() => {
    if (openMetacultureDialog) {
      loadMetacultureData();
    }
  }, [openMetacultureDialog]);

  useEffect(() => {
    if (addCultureModal) {
      loadInvertedCultureBySwitch();
    }
  }, [addCultureModal]);

  const processRowUpdate = useCallback(
    async (updatedRow, previousRow) => {
      errorsFormDefault.formError = false;
      errorsFormCoProduct.formError = false;
      errorsFormEconomicValue.formError = false;
      setErrorCoProductsMessages([]);

      const cultureId = cultures.find((culture) => culture.id === updatedRow.id)?.id;
      const toUpdate = getOnlyAttributeUpdated(previousRow, updatedRow);

      if (!toUpdate.hasOwnProperty('irrigationWaterNeeded')) {
        toUpdate.irrigationWaterNeeded = previousRow.irrigationWaterNeeded;
      }

      if (Object.entries(toUpdate).length > 0) {
        if (updatedRow?.parentName && toUpdate.hasOwnProperty('name')) {
          toUpdate.name = getStringInsideParentheses(toUpdate.name) ?? toUpdate.name;
        }
        const dataToValidate = { ...updatedRow, ...toUpdate };
        setErrorsFormDefault({
          ...validateDatagridData(
            dataToValidate,
            errorsFormDefault,
            processedColumns,
            updatedRow.id,
            null,
            cultures,
          ),
        });
        setErrorsFormEconomicValue({
          ...validateDatagridData(
            toUpdate,
            errorsFormEconomicValue,
            processedColumns,
            updatedRow.id,
          ),
        });

        const isError =
          errorsFormDefault.formError ||
          errorsFormCoProduct.formError ||
          errorsFormEconomicValue.formError;

        if (isError && Object.keys(rowModesModel).length > 1) {
          resetErrorsForm(errorsFormDefault, errorsFormEconomicValue, errorsFormCoProduct);

          for (const key in rowModesModel) {
            if (rowModesModel[key]?.fromAction) {
              toast.error(t('errors.editError'));
            }
          }

          return previousRow;
        }

        if (toUpdate.hasOwnProperty('necessaryNitrogenQuantity')) {
          toUpdate.necessaryNitrogenQuantity =
            toUpdate.necessaryNitrogenQuantity ?? updatedRow.necessaryNitrogenQuantity;
        }

        if (toUpdate.hasOwnProperty('nitrogenBonus')) {
          toUpdate.nitrogenBonus = toUpdate.nitrogenBonus ?? updatedRow.nitrogenBonus;
        }

        if (toUpdate.hasOwnProperty('nitrogenLimit')) {
          toUpdate.nitrogenLimit = toUpdate.nitrogenLimit ?? updatedRow.nitrogenLimit;
        }

        if (!toUpdate.hasOwnProperty('coProduct') && toUpdate.hasOwnProperty('yieldProduct')) {
          const updatedCoProducts = toUpdate.yieldProduct.map((_, index) => {
            const temp = updatedRow.coProducts[index];
            return {
              id: temp.id,
              name: temp.name,
              displayName: temp.displayName,
              yield: toUpdate.yieldProduct[index],
            };
          });
          toUpdate.coProducts = updatedCoProducts;
          delete toUpdate.yieldProduct;
          delete updatedRow.yieldProduct;
          delete updatedRow.coProduct;
        }
        if (toUpdate.hasOwnProperty('coProduct')) {
          const updatedCoProducts = toUpdate?.coProduct?.map((coProductItem, index) => {
            const temp = coProductsList.find(
              (coProductsListItem) => coProductsListItem?.displayName === coProductItem,
            );

            return {
              id: temp.id,
              name: temp.name,
              displayName: temp.displayName,
              yield: updatedRow.yieldProduct[index],
            };
          });

          toUpdate.coProducts = updatedCoProducts;
          delete toUpdate.coProduct;
        }

        let coProductErrorMessagesArray = [];
        if (toUpdate.hasOwnProperty('coProducts')) {
          for (const key in toUpdate.coProducts) {
            const validateCoProduct = validateDatagridData(
              toUpdate.coProducts[key],
              errorsFormCoProduct,
              processedColumns,
              updatedRow.id,
              toUpdate.coProducts[key].displayName,
            );
            if (validateCoProduct.yield.message) {
              coProductErrorMessagesArray[key] = validateCoProduct.yield.message;
            }
            setErrorsFormCoProduct({
              ...validateCoProduct,
            });
          }
          setErrorCoProductsMessages(coProductErrorMessagesArray);
        }
        if (toUpdate.hasOwnProperty('price') && !toUpdate.hasOwnProperty('priceN5')) {
          toUpdate.economicAttributeCollection = {
            price: {
              currentEconomicValue: toUpdate.price ?? updatedRow.price,
              futureEconomicValue: toUpdate.price ?? updatedRow.priceN5,
            },
          };
          toUpdate.hasOwnProperty('price') && delete toUpdate.price;
        } else if (toUpdate.hasOwnProperty('price') || toUpdate.hasOwnProperty('priceN5')) {
          toUpdate.economicAttributeCollection = {
            price: {
              currentEconomicValue: toUpdate.price ?? updatedRow.price,
              futureEconomicValue: toUpdate.hasOwnProperty('priceN5')
                ? copyCurrentValueToFuture(toUpdate.priceN5, updatedRow.price)
                : updatedRow.priceN5,
            },
          };
          toUpdate.hasOwnProperty('price') && delete toUpdate.price;
          toUpdate.hasOwnProperty('priceN5') && delete toUpdate.priceN5;
        }

        await handleRowUpdateValidation(
          updatedRow,
          errorsFormDefault,
          errorsFormCoProduct,
          errorsFormEconomicValue,
        );

        if (previousRow.irrigationWaterNeeded === updatedRow.irrigationWaterNeeded) {
          delete toUpdate?.irrigationWaterNeeded;
        }

        if (Object.keys(toUpdate).length === 0) {
          return previousRow;
        }

        toUpdate.isOrganic = updatedRow.isOrganic;

        try {
          switch (from) {
            case 'fromCooperative':
              await updateCulture(toUpdate, cultureId);
              break;
            case 'fromSector':
              await updateSectorCulture(sector.id, toUpdate, cultureId);
              break;
            case 'fromExploitation':
              await updateExploitationCulture(exploitation.id, toUpdate, cultureId);
              break;
          }
          toast.success(t('success.cultureUpdated', { name: updatedRow.name }));
          refreshData(
            isOrganic,
            from === 'fromCooperative' ? cooperativeId : sector ? sector?.id : exploitation?.id,
          );
          stackedRequestsRef.current = [];
        } catch (err) {
          if (
            err.response.data.message ===
            `A culture already exists with the name ${updatedRow.name}`
          ) {
            toast.error(t('errors.cultureAlreadyExists', { name: updatedRow.name }));
          } else {
            toast.error(displayErrorMessage('ERR_UNEXPECTED'));
          }
          stackedRequestsRef.current = [];
        }

        return updatedRow;
      }

      return previousRow;
    },
    [cultures, coProductsList, rowModesModel, t],
  );

  const resetAllCultures = async () => {
    setOpenResetDialog(false);

    try {
      if (from === 'fromSector') {
        await resetSectorCultures(sector);
        toast.success(t('success.culturesReset', { name: sector.name }));
      } else if (from === 'fromExploitation') {
        await resetCultures(exploitation, isOrganic);
        toast.success(t('success.culturesReset', { name: exploitation.name }));
      }
    } catch (error) {
      toast.error(displayErrorMessage('ERR_REINIT_CULTURE'));
    } finally {
      refreshData(isOrganic, sector ? sector?.id : exploitation?.id);
    }
  };

  useEffect(() => {
    setNitrogenPriceValue((prev) => ({
      ...prev,
      nitrogenPrice: economicAttribute?.[organicState]?.nitrogenPrice?.currentEconomicValue ?? 0,
      nitrogenPriceN5:
        economicAttribute?.[organicState]?.nitrogenPrice?.futureEconomicValue ??
        economicAttribute?.[organicState]?.nitrogenPrice?.currentEconomicValue ??
        0,
    }));
  }, [economicAttribute, isOrganic]);

  return (
    cultures && (
      <div className="section">
        <div className="main_container">
          <div className="override">
            {from !== 'fromExploitation' && (
              <h1 className="title_section title_section_culture">{t('title.cultureList')}</h1>
            )}
            <div className="contain_header_icon">
              {renderToggleSwitch()}
              <ThemeProvider theme={customButtonTheme}>
                <Box className="buttons_container">
                  <div className="mui_icon_header">
                    <Button
                      onClick={() => setOpenOffCropSettingsDialog(!openOffCropSettingsDialog)}
                    >
                      {t('title.offCropSettings')}
                    </Button>
                  </div>
                </Box>
              </ThemeProvider>
            </div>
          </div>
          <div className="datagrid_container">
            <div
              style={{
                width: '100%',
                margin: 'auto',
              }}
            >
              <CustomDataGrid
                rows={rows}
                fromCultures
                columns={processedColumns}
                sortModel={sortModel}
                setSortModel={setSortModel}
                onRowSelectionModelChange={setSelectedRows}
                rowSelectionModel={selectedRows}
                rowModesModel={rowModesModel}
                setRowModesModel={setRowModesModel}
                loading={dataGridLoading}
                columnVisibilityModel={columnVisible}
                toggleVisibilityFilter={toggleVisibilityFilter}
                setColumnVisibilityModel={setColumnVisible}
                processRowUpdate={processRowUpdate}
                isLargeGrid={isLargeGrid}
                disableColumnResize={true}
                isEditCoProduct={isEditCoProduct}
                isEditInputCost={isEditInputCost}
                isEditableIFT={isEditableIFT}
                isEditMetaculture={isEditMetaculture}
                from={from}
                selectedRows={selectedRows}
                handleVisibility={handleVisibility}
                handleCulturesShow={handleCulturesShow}
                handleCulturesHide={handleCulturesHide}
                badgeContent={badgeContent}
                addCultureModal={addCultureModal}
                loadMetacultureData={loadMetacultureData}
                setAddCultureModal={setAddCultureModal}
                setOpenResetDialog={setOpenResetDialog}
                organicState={organicState}
                isOrganic={isOrganic}
                stackedRequestsRef={stackedRequestsRef}
              />
            </div>
          </div>
        </div>
        {invertedCultures &&
          Array.isArray(invertedCultures) &&
          invertedCultures.length > 0 &&
          renderDeleteDialog()}
        {renderDuplicateDialog()}
        {renderDeleteEffectsDialog()}
        {renderResetDialog(openResetDialog, setOpenResetDialog, resetAllCultures)}
        {openInputCostDialog &&
          (nitrogenPriceValue?.nitrogenPrice !== 0 ? (
            <InputCostModalNitrogen
              openInputCostDialog={openInputCostDialog}
              setOpenInputCostDialog={setOpenInputCostDialog}
              inputCostValue={inputCostValue}
              refreshData={refreshData}
              cooperativeId={cooperativeId}
              paramsInputCost={paramsInputCost}
              setParamsInputCost={setParamsInputCost}
              errorsFormDefault={errorsFormDefault}
              setErrorsFormDefault={setErrorsFormDefault}
              columns={processedColumns}
              owner={
                from !== 'fromCooperative'
                  ? { parent: from, id: sector ? sector.id : exploitation.id }
                  : null
              }
              updatedRow={rows.find((row) => row.id === inputCostValue.cultureId)}
              nitrogenPriceValue={nitrogenPriceValue}
              isOrganic={isOrganic}
            />
          ) : (
            <InputCostModal
              openInputCostDialog={openInputCostDialog}
              setOpenInputCostDialog={setOpenInputCostDialog}
              inputCostValue={inputCostValue}
              refreshData={refreshData}
              cooperativeId={cooperativeId}
              paramsInputCost={paramsInputCost}
              setParamsInputCost={setParamsInputCost}
              errorsFormDefault={errorsFormDefault}
              setErrorsFormDefault={setErrorsFormDefault}
              columns={processedColumns}
              owner={
                from !== 'fromCooperative'
                  ? { parent: from, id: sector ? sector.id : exploitation.id }
                  : null
              }
              updatedRow={rows.find((row) => row.id === inputCostValue.cultureId)}
              isOrganic={isOrganic}
            />
          ))}
        {openOffCropSettingsDialog && (
          <OffCropSettingsModal
            openOffCropSettingsDialog={openOffCropSettingsDialog}
            setOpenOffCropSettingsDialog={setOpenOffCropSettingsDialog}
            errorsFormDefault={errorsFormDefault}
            setErrorsFormDefault={setErrorsFormDefault}
            owner={
              from !== 'fromCooperative'
                ? { parent: from, id: sector ? sector.id : exploitation.id }
                : null
            }
            nitrogenPriceValue={nitrogenPriceValue}
            getOffCropSettings={getOffCropSettings}
            errorsFormOffCropSettings={errorsFormOffCropSettings}
            setErrorsFormOffCropSettings={setErrorsFormOffCropSettings}
            cooperativeId={cooperativeId}
            cooperativeName={cooperativeName}
            nitrogenCover={nitrogenCover}
            nitrogenSupplyByCoverOrganic={nitrogenSupplyByCoverOrganic}
            from={from}
            sector={sector}
            exploitation={exploitation}
            biomassSupplyByCover={biomassSupplyByCover}
            isOrganic={isOrganic}
          />
        )}
        {openMetacultureDialog && (
          <MetaCultureModal
            openMetacultureDialog={openMetacultureDialog}
            setOpenMetacultureDialog={setOpenMetacultureDialog}
            metacultureValue={metacultureValue}
            refreshData={refreshData}
            cooperativeId={cooperativeId}
            errorsFormDefault={errorsFormMetaculture}
            owner={
              from !== 'fromCooperative'
                ? { parent: from, id: sector ? sector.id : exploitation.id }
                : null
            }
            updatedRow={rows.find((row) => row.id === metacultureValue.cultureId)}
            metaculture={metaculture}
            isOrganic={isOrganic}
          />
        )}
        {openIFTDialog && (
          <IFTModal
            openIFTDialog={openIFTDialog}
            setOpenIFTDialog={setOpenIFTDialog}
            refreshData={refreshData}
            cooperativeId={cooperativeId}
            isOrganic={isOrganic}
            errorsFormDefault={errorsFormDefault}
            setErrorsFormDefault={setErrorsFormDefault}
            columns={processedColumns}
            IFTValue={IFTValue}
            owner={
              from !== 'fromCooperative'
                ? { parent: from, id: sector ? sector.id : exploitation.id }
                : null
            }
            updatedRow={rows.find((row) => row.id === IFTValue.cultureId)}
          />
        )}
        {addCultureModal &&
          invertedCultures &&
          metaculture?.length > 0 &&
          (nitrogenPriceValue?.nitrogenPrice !== 0 ? (
            <AddCultureModalNitrogen
              modal={addCultureModal}
              setModal={setAddCultureModal}
              onSubmitSuccess={formSuccess}
              role={user?.role}
              cultures={cultures}
              metaculture={metaculture}
              isOrganic={isOrganic}
              invertedCultures={invertedCultures}
            />
          ) : (
            <AddCultureModal
              modal={addCultureModal}
              setModal={setAddCultureModal}
              onSubmitSuccess={formSuccess}
              role={user?.role}
              cultures={cultures}
              metaculture={metaculture}
              isOrganic={isOrganic}
              invertedCultures={invertedCultures}
            />
          ))}
      </div>
    )
  );
};

export default DataGridCulture;
